var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-dialog"},[_c('el-dialog',{attrs:{"close-on-click-modal":_vm.closeOnclickModal,"close-on-press-escape":false,"show-close":false,"visible":_vm.dialogVisible,"custom-class":"width-dialog-sm-and-down","top":_vm.top,"width":_vm.width},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }